export default __webpack_public_path__ + "static/SR France - HACCP - Note d'information-fc6163250ccd252a690fdb8ba533b7b3.pdf";